import { useState } from 'react';
import dayjs, { type Dayjs } from 'dayjs';
import { useMutation } from '@tanstack/react-query';
import { Box, Button, CircularProgress, Paper, Stack, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { listVirtualPosTransactions } from '../../../api/endpoints/pos';
import { ApiErrorAlert } from '../../../components/ApiErrorAlert';
import { DynamicReportTable } from '../../../components/report/DynamicReportTable';

/**
 * Pos İşlem Raporları — `VirtualPos/ListTransactions` (backend'de mevcut, 2026-08-31
 * doğrulandı). Tarihler dd.MM.yyyy formatında gönderilir; Master GSA tüm GSA'ların
 * işlemlerini, diğerleri yalnızca kendi GSA'sınınkileri görür.
 */
export default function PosReportPage() {
  const [start, setStart] = useState<Dayjs | null>(dayjs().startOf('month'));
  const [end, setEnd] = useState<Dayjs | null>(dayjs());

  const report = useMutation({
    mutationFn: () =>
      listVirtualPosTransactions({
        startDate: (start ?? dayjs()).format('DD.MM.YYYY'),
        endDate: (end ?? dayjs()).format('DD.MM.YYYY'),
      }),
  });

  const rows = (report.data?.transactions ?? []) as Record<string, unknown>[];

  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        Pos İşlem Raporları
      </Typography>

      <Paper variant="outlined" sx={{ p: 2, mb: 3 }}>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
          <DatePicker label="Başlangıç" value={start} onChange={setStart} slotProps={{ textField: { size: 'small' } }} />
          <DatePicker label="Bitiş" value={end} onChange={setEnd} slotProps={{ textField: { size: 'small' } }} />
          <Button variant="contained" onClick={() => report.mutate()} disabled={report.isPending}>
            {report.isPending ? 'Getiriliyor…' : 'Raporu Getir'}
          </Button>
        </Stack>
        <ApiErrorAlert error={report.error} sx={{ mt: 2 }} />
      </Paper>

      {report.isPending && <CircularProgress size={24} />}
      {report.isSuccess && <DynamicReportTable rows={rows} fileName="pos-islem-raporu" />}
    </Box>
  );
}
